import { useRef } from 'react';

import { View } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';

export interface ModelPreviewPanelProps {
  children: React.ReactNode;
  type?: 'canvas' | 'image';
}

export const ModelPreviewPanel: React.FC<ModelPreviewPanelProps> = ({
  children,
  type = 'image',
}) => {
  const eventSourceRef = useRef<HTMLDivElement>(null!);

  return (
    <div ref={eventSourceRef} style={{ position: 'relative', width: '100%' }}>
      {type === 'canvas' && (
        <Canvas
          shadows
          eventSource={eventSourceRef}
          frameloop="demand"
          style={{ position: 'absolute', inset: 0 }}
        >
          <View.Port />
        </Canvas>
      )}
      {children}
    </div>
  );
};
